// NATIVE


// INSTALLED
import Avatar from '@mui/material/Avatar';


// CUSTOM


/**
 * LogoPlatform component renders an Avatar with a predefined image.
 *
 * @component
 * @example
 * return (
 *   <LogoPlatform />
 * )
 *
 * @returns {JSX.Element} The rendered Avatar component.
 */
export const LogoPlatform = () => {


  // REDUX

  return (
    <Avatar alt="Qihotels" src={`${window.location.origin}/favicon_redondo.png`}/>
  )
}